<template>
  <div>
    this is only a placeholder for the new plan page
  </div>
</template>
